import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * ProjectSelect — small reusable dropdown for the project_code field.
 * Lazy-loads active projects on mount.
 */
export default function ProjectSelect({ value, onChange, includeBlank = true, testId, ...rest }) {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/projects?active_only=true");
        if (!cancelled) setProjects(data);
      } catch (e) { if (process.env.NODE_ENV !== "production") console.debug("projects:", e); }
    })();
    return () => { cancelled = true; };
  }, []);
  return (
    <select
      data-testid={testId}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full border border-[#e4e4e7] bg-white px-3 py-2 text-sm focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20 outline-none"
      {...rest}
    >
      {includeBlank && <option value="">—</option>}
      {projects.map((p) => (
        <option key={p.code} value={p.code}>{`${p.code} — ${p.name}`}</option>
      ))}
    </select>
  );
}
